import "./conversation-entry.css";
import * as ConversationEntryUtil from "../helpers/conversationEntryUtil";

// Import children components to plug in and render.
import TextMessage from "./TextMessage";
import ParticipantChange from "./ParticipantChange";
import FileMessage from "./FileMessage";

export default function ConversationEntry({conversationEntry}) {

    /**
     * Render appropriate message component based on entry type
     */
    function renderMessageContent() {
        // Check if message has actual file attachments (not Link/RichLink which are URLs)
        const attachments = Array.isArray(conversationEntry.attachments) ? conversationEntry.attachments : [];
        const hasFileAttachments = attachments.some(att => {
            const isLinkType = att && (att.type === "Link" || att.type === "RichLink");
            // Agent-sent images arrive with type "Image" (no mimeType/fileId) — treat as file
            const looksLikeFile = att && (att.mimeType || att.fileId || att.type === "Image");
            return !isLinkType && !!looksLikeFile;
        });

        // If message has file attachments, render FileMessage
        if (hasFileAttachments) {
            return <FileMessage conversationEntry={conversationEntry} />;
        }

        // Render component for a conversation entry of type Text Message
        if (ConversationEntryUtil.isTextMessage(conversationEntry)) {
            return <TextMessage conversationEntry={conversationEntry} />;
        }

        // Render component for a conversation entry of type Participant Change
        if (ConversationEntryUtil.isParticipantChangeEvent(conversationEntry)) {
            return <ParticipantChange conversationEntry={conversationEntry} />;
        }

        return null;
    }

    return (
        <>
            <div className="conversationEntryContainer">
                {renderMessageContent()}
            </div>
        </>
    );
}